<template>
   <el-dialog title="商品批号查询" :visible.sync="dialogVisible" width="80%" @open="onDialogOpen" @close="onDialogClose" append-to-body :close-on-click-modal="false">
      <!-- 商品信息显示 -->
      <div v-if="selectedProduct" class="product-info-section">
         <h4>商品信息</h4>
         <div class="product-info-grid">
            <div class="info-item">
               <label>商品编码：</label>
               <span>{{ selectedProduct.bgmCode }}</span>
            </div>
            <div class="info-item">
               <label>商品名称：</label>
               <span>{{ selectedProduct.bgmName }}</span>
            </div>
            <div class="info-item">
               <label>规格：</label>
               <span>{{ selectedProduct.spec }}</span>
            </div>
            <div class="info-item">
               <label>生产厂家：</label>
               <span>{{ selectedProduct.manufacturer }}</span>
            </div>
         </div>
      </div>

      <!-- 批号列表 -->
      <div class="batch-list-section">
         <h4>批号信息 - 请为需要的批号填写数量</h4>
         <el-table ref="batchTable" :data="batchList" border height="400px" @keydown.native="handleBatchTableKeyDown" tabindex="0" :row-class-name="getBatchRowClassName">
            <el-table-column prop="batchno" label="批号" width="120" />
            <el-table-column prop="num" label="库存数量" width="80" />
            <el-table-column label="录入数量" width="120">
               <template slot-scope="scope">
                  <el-input 
                     v-model="scope.row.inputQuantity" 
                     :min="0" 
                     :max="scope.row.num" 
                     type="number"
                     size="mini"
                     placeholder="数量"
                     @change="onQuantityChange(scope.row, scope.$index)"
                     @keydown.enter.native="focusNextInput(scope.$index)"
                  />
               </template>
            </el-table-column>
            <el-table-column prop="prodate" label="生产日期" width="100">
               <template slot-scope="scope">
                  <span>{{ formatDate(scope.row.prodate) }}</span>
               </template>
            </el-table-column>
            <el-table-column prop="expidate" label="失效日期" width="100">
               <template slot-scope="scope">
                  <span>{{ formatDate(scope.row.expidate) }}</span>
               </template>
            </el-table-column>
            <el-table-column prop="price" label="零售价" width="70" />
            <el-table-column prop="memberPrice" label="会员价" width="70" />
            <el-table-column prop="shelfCode" label="货架号" width="80" />
             <el-table-column prop="bgiPretype" label="处方类型" width="120" />
            <el-table-column prop="shelfCode" label="货架号" width="120" />
            <el-table-column prop="bgiType" label="商品类型" width="120" />
            <el-table-column prop="bgiAppnumber" label="批准文号" width="120" show-overflow-tooltip />
            <el-table-column prop="bgiPerholder" label="上市许可持有人" width="120" show-overflow-tooltip />
         </el-table>
      </div>

      <span slot="footer" class="dialog-footer">
         <div class="footer-info">
            <span>上下键切换行，Enter键跳转下一个输入框，ESC键关闭</span>
         </div>
         <el-button type="primary" @click="onConfirm" :disabled="filledBatchCount === 0">
            确认添加 
         </el-button>
      </span>
   </el-dialog>
</template>

<script>
export default {
   name: 'ProductBatchDialog',
   props: {
      visible: {
         type: Boolean,
         default: false
      },
      selectedProduct: {
         type: Object,
         default: null
      },
      curDate: {
         type: Number,
         default: 0
      },
      curTime: {
         type: Number,
         default: 0
      },
      day: {
         type: Number,
         default: 0
      },
      week: {
         type: Number,
         default: 0
      },
      storeId: {
         type: Number,
         default: 0
      },
      isZero: {
         type: Number,
         default: 0
      }
   },
   data() {
      return {
         dialogVisible: false,
         batchList: [],
         selectedBatch: null,
         selectedBatchIndex: -1,
         loading: false
      }
   },
   computed: {
      // 已填写数量的批号数量
      filledBatchCount() {
         return this.batchList.filter(batch => batch.inputQuantity && batch.inputQuantity > 0).length;
      },
      // 总录入数量
      totalInputQuantity() {
         return this.batchList.reduce((total, batch) => {
            return total + (batch.inputQuantity || 0);
         }, 0);
      }
   },
   watch: {
      visible(newVal) {
         this.dialogVisible = newVal;
         if (newVal && this.selectedProduct) {
            this.loadBatchList();
         }
      },
      dialogVisible(newVal) {
         this.$emit('update:visible', newVal);
      }
   },
   methods: {
      // 弹窗打开事件
      onDialogOpen() {
         this.$emit('opened');
         // 聚焦到表格以便键盘操作
         this.$nextTick(() => {
            if (this.$refs.batchTable) {
               this.$refs.batchTable.$el.focus();
            }
         });
      },

      // 弹窗关闭事件
      onDialogClose() {
         this.resetDialog();
         this.$emit('close');
      },

      // 重置弹窗状态
      resetDialog() {
         this.batchList = [];
         this.selectedBatch = null;
         this.selectedBatchIndex = -1;
         this.loading = false;
      },

      // 加载批号列表
      async loadBatchList() {
         if (!this.selectedProduct || !this.selectedProduct.bgmId) {
            this.$message.warning('请先选择商品');
            return;
         }

         this.loading = true;
         try {
            // 调用API获取批号信息
            const res = await this.$http.getRetailBgmInfo({
               bgmName: this.selectedProduct.bgmName,
               bgmId: this.selectedProduct.bgmId,
               curDate: this.curDate,
               curTime: this.curTime,
               day: this.day,
               storeId: this.storeId,
               week: this.week,
               isZero:this.isZero
               // isZy:0//是否中药
            });

            if (res && res.status === 200 && res.result) {
               // 为每个批号初始化输入数量
               this.batchList = res.result.map(batch => ({
                  ...batch,
                  inputQuantity: 0 // 初始化录入数量为0
               }));
               
               // 初始化选中状态
               if (this.batchList.length > 0) {
                  this.selectedBatchIndex = 0;
                  this.selectedBatch = this.batchList[0];
               }
               
               // 聚焦到第一个数量输入框
               this.$nextTick(() => {
                  this.focusFirstInput();
               });
            } else {
               this.batchList = [];
               this.$message.info('该商品暂无批号信息');
            }
         } catch (error) {
            console.error('获取批号列表失败:', error);
            this.$message.error('获取批号列表失败');
            this.batchList = [];
         } finally {
            this.loading = false;
         }
      },

      // 数量变化事件
      onQuantityChange(row, index) {
         // 验证数量不能超过库存
         if (row.inputQuantity > row.num) {
            this.$message.warning(`录入数量不能超过库存数量 ${row.num}`);
            row.inputQuantity = row.num;
         }
         
         // 验证数量不能小于0
         if (row.inputQuantity < 0) {
            row.inputQuantity = 0;
         }
      },

      // 聚焦到第一个输入框
      focusFirstInput() {
         if (this.batchList.length > 0) {
            this.focusInputByIndex(0);
         }
      },

      // 聚焦到指定索引的输入框
      focusInputByIndex(index) {
         this.$nextTick(() => {
            const table = this.$refs.batchTable;
            if (table && table.$el) {
               const inputElements = table.$el.querySelectorAll('.el-input input');
               if (inputElements[index]) {
                  inputElements[index].focus();
                  inputElements[index].select();
               }
            }
         });
      },

      // Enter键跳转到下一个输入框
      focusNextInput(currentIndex) {
         const nextIndex = currentIndex + 1;
         if (nextIndex < this.batchList.length) {
            this.focusInputByIndex(nextIndex);
         } else {
            // 如果是最后一个，聚焦到确认按钮
            this.$nextTick(() => {
               const confirmBtn = this.$el.querySelector('.el-button--primary');
               if (confirmBtn) {
                  confirmBtn.focus();
               }
            });
         }
      },

      // 批号表格键盘事件
      handleBatchTableKeyDown(event) {
         if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
            event.preventDefault();

            let newIndex = this.selectedBatchIndex;
            if (event.key === 'ArrowUp') {
               newIndex = Math.max(0, this.selectedBatchIndex - 1);
            } else if (event.key === 'ArrowDown') {
               newIndex = Math.min(this.batchList.length - 1, this.selectedBatchIndex + 1);
            }

            if (newIndex !== this.selectedBatchIndex && newIndex >= 0 && newIndex < this.batchList.length) {
               this.selectedBatchIndex = newIndex;
               this.selectedBatch = this.batchList[newIndex];

               // 聚焦到对应行的数量输入框
               this.focusInputByIndex(newIndex);
            }
         } else if (event.key === 'Enter') {
            event.preventDefault();
            if (this.selectedBatch) {
               this.onConfirm();
            }
         } else if (event.key === 'Escape') {
            event.preventDefault();
            this.onCancel();
         }
      },

      // 获取批号行样式类名
      getBatchRowClassName({ row, rowIndex }) {
         if (rowIndex === this.selectedBatchIndex) {
            return 'selected-batch-row';
         }
         return '';
      },

      // 格式化日期
      formatDate(timestamp) {
         if (!timestamp) return '';
         return this.$common.getLocalTime(timestamp);
      },

      // 获取状态标签类型
      getStatusTagType(row) {
         if (!row.expidate) return '';

         const now = Date.now();
         let expTimestamp = row.expidate;

         if (typeof expTimestamp === "string") {
            expTimestamp = new Date(expTimestamp).getTime();
         }
         if (expTimestamp < 1e12) {
            expTimestamp = expTimestamp * 1000;
         }

         if (expTimestamp < now) {
            return 'danger'; // 已过期
         } else if (expTimestamp - now < 30 * 24 * 60 * 60 * 1000) {
            return 'warning'; // 30天内过期
         } else {
            return 'success'; // 正常
         }
      },

      // 获取状态文本
      getStatusText(row) {
         if (!row.expidate) return '正常';

         const now = Date.now();
         let expTimestamp = row.expidate;

         if (typeof expTimestamp === "string") {
            expTimestamp = new Date(expTimestamp).getTime();
         }
         if (expTimestamp < 1e12) {
            expTimestamp = expTimestamp * 1000;
         }

         if (expTimestamp < now) {
            return '已过期';
         } else if (expTimestamp - now < 30 * 24 * 60 * 60 * 1000) {
            return '近效期';
         } else {
            return '正常';
         }
      },

      // 确认添加
      onConfirm() {
         // 获取所有填写了数量的批号
         const validBatches = this.batchList.filter(batch => batch.inputQuantity && batch.inputQuantity > 0);
         
         if (validBatches.length === 0) {
            this.$message.warning('请至少为一个批号填写数量');
            return;
         }

         // 发送所有有效批号数据
         this.$emit('confirm', {
            product: this.selectedProduct,
            batches: validBatches
         });
         
         this.dialogVisible = false;
      },

      // 取消
      onCancel() {
         this.dialogVisible = false;
      }
   }
}
</script>

<style scoped>
.product-info-section {
   margin-bottom: 20px;
   padding: 15px;
   background-color: #f5f7fa;
   border-radius: 4px;
}

.product-info-section h4 {
   margin: 0 0 10px 0;
   color: #303133;
   font-size: 14px;
   font-weight: bold;
}

.product-info-grid {
   display: grid;
   grid-template-columns: repeat(2, 1fr);
   gap: 10px;
}

.info-item {
   display: flex;
   align-items: center;
}

.info-item label {
   font-weight: bold;
   color: #606266;
   margin-right: 8px;
   min-width: 80px;
}

.info-item span {
   color: #303133;
}

.batch-list-section h4 {
   margin: 0 0 10px 0;
   color: #303133;
   font-size: 14px;
   font-weight: bold;
}

.dialog-footer {
   display: flex;
   justify-content: space-between;
   align-items: center;
}

.footer-info {
   font-size: 12px;
   color: #909399;
}


/* 选中行样式 */
::v-deep .selected-batch-row {
   background-color: #ffdb12  !important;
   color: white !important;
}

::v-deep .selected-batch-row td {
   background-color: #ffdb12 !important;
   color: white !important;
}

/* 选中行中的输入框样式 */
::v-deep .selected-batch-row .el-input input {
   background-color: white !important;
   color: #303133 !important;
   border-color: #dcdfe6 !important;
}



/* 标签样式优化 */
::v-deep .el-tag {
   border: none;
}

/* 输入框样式优化 */
::v-deep .el-input-number {
   width: 100%;
}

::v-deep .el-input-number .el-input__inner {
   text-align: center;
}
</style>
